import { QueryParams } from '@/model';
import apiClient from '../api/apiClient';
import { buildApiUrl } from '../utils';
import {
  GetTeamAnthemByIdResponse,
  GetTeamAnthemResponse,
  PostTeamAnthemResponse,
  PutTeamAnthemResponse,
} from '../response/anthem';

export class AnthemService {
  static getAnthem(params?: QueryParams) {
    return apiClient.get<GetTeamAnthemResponse>(buildApiUrl('/api/v1/team/anthem'), params);
  }

  static putAnthem(id: string, data: any) {
    const url = buildApiUrl('/api/v1/team/anthem/:id', { id });
    return apiClient.updateWithFile<PutTeamAnthemResponse>(url, data);
  }

  static getAnthemByUUID(id: string) {
    const url = buildApiUrl('/api/v1/team/anthem/:id', { id });
    return apiClient.get<GetTeamAnthemByIdResponse>(url, undefined);
  }

  static postAnthem(data: any) {
    return apiClient.createWithFile<PostTeamAnthemResponse>(buildApiUrl('/api/v1/team/anthem'), data);
  }

  static deleteAnthem(id: string) {
    const url = buildApiUrl('/api/v1/team/anthem/:id', { id });
    return apiClient.delete<void>(url);
  }

  static deleteAnthemFile(id: string) {
    const url = buildApiUrl('/api/v1/team/anthem/:id/file', { id });
    return apiClient.delete<void>(url);
  }
}
